/** Streams that belong to other Peak sites. Signup must never report into these. */
const BLOCKED_MEASUREMENT_IDS = new Set([
  "G-Y8DNP0FGD8",
  "G-G31Q27H79T",
  "G-6HYPNC53EN",
]);

const BLOCKED_APP_IDS = new Set([
  "1:377620642931:web:704b27d79e552b6fe53e06",
  "1:377620642931:web:5d55564f395e18c0e53e06",
  "1:710805219697:web:835bf45ac524611f6eaed0",
]);

export interface AnalyticsStream {
  appId: string;
  measurementId: string;
}

/** Empty, missing, or another site's ids mean analytics stays off. */
export function resolveAnalyticsStream(
  authAppId: string,
  appId: string | undefined,
  measurementId: string | undefined,
): AnalyticsStream | null {
  const resolvedAppId = (appId || "").trim();
  const resolvedMeasurementId = (measurementId || "").trim();
  if (!resolvedAppId || !resolvedMeasurementId) return null;
  if (BLOCKED_MEASUREMENT_IDS.has(resolvedMeasurementId)) return null;
  if (BLOCKED_APP_IDS.has(resolvedAppId)) return null;
  if (resolvedAppId === authAppId) return null;
  return { appId: resolvedAppId, measurementId: resolvedMeasurementId };
}
